import { type ParsedUrlQuery } from 'node:querystring'

export default function isLoadedInAppView(query: ParsedUrlQuery) {
  const { NEGOTIATORAPP, negotiatorapp } = query
  return NEGOTIATORAPP !== undefined || negotiatorapp !== undefined
}
